import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ParkingFinanceListRow } from '../../../../../../core/models/finance/parking-finance.model';
import { ModalAdminActivityHistoryComponent } from '../../../system-settings/modal-admin-activity-history/modal-admin-activity-history.component';
import { AdminActivityEntityTypes } from '../../../../../../core/models/system-settings/admin-activity-log.model';
import { VatSettingService } from '../../../../../../core/services/vat-setting.service';
import { FinanceAttachmentsComponent } from '../../../../../../shared/components/finance-attachments/finance-attachments.component';

@Component({
  selector: 'app-modal-parking-fine-detail',
  standalone: true,
  imports: [CommonModule, ModalAdminActivityHistoryComponent, FinanceAttachmentsComponent],
  providers: [DatePipe],
  templateUrl: './modal-parking-fine-detail.component.html',
  styleUrl: './modal-parking-fine-detail.component.css'
})
export class ModalParkingFineDetailComponent {
  private datePipe = inject(DatePipe);
  readonly vatSetting = inject(VatSettingService);

  @Input() record: ParkingFinanceListRow | null = null;
  @Input() hasEditPermission = false;
  @Input() hasUpdatePermission = false;
  @Input() hasDeletePermission = false;
  @Input() siteId = 0;
  @Input() userId = 0;

  @Output() close = new EventEmitter<void>();
  @Output() cancelRequest = new EventEmitter<ParkingFinanceListRow>();
  @Output() viewReceipt = new EventEmitter<ParkingFinanceListRow>();

  readonly activityEntityTypes = AdminActivityEntityTypes;
  showActivityHistory = false;

  // ================= Normal Functions =================

  /** Close modal trigger */
  onClose(): void {
    this.close.emit();
  }

  /** Trigger cancel from detail trigger */
  onCancel(): void {
    if (this.record) {
      this.cancelRequest.emit(this.record);
    }
  }

  /** View receipt trigger */
  onViewReceipt(): void {
    if (this.record) {
      this.viewReceipt.emit(this.record);
    }
  }

  /** Checks if the paidDate matches today's date */
  isToday(dateStr: string | null | undefined): boolean {
    if (!dateStr) return false;
    const d = new Date(dateStr);
    const today = new Date();
    return d.getFullYear() === today.getFullYear() &&
           d.getMonth() === today.getMonth() &&
           d.getDate() === today.getDate();
  }

  /** Display date conversion helper */
  formatDateDisplay(date: Date | string | null | undefined): string {
    if (!date) return '-';
    const d = date instanceof Date ? date : new Date(date);
    if (isNaN(d.getTime())) return '-';
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    const hh = String(d.getHours()).padStart(2, '0');
    const mm = String(d.getMinutes()).padStart(2, '0');
    return `${day}/${month}/${year} ${hh}:${mm}`;
  }

  get canShowActivityHistory(): boolean {
    return !!this.record?.id && this.record.id > 0;
  }

  openActivityHistory(): void {
    if (!this.canShowActivityHistory) return;
    this.showActivityHistory = true;
  }

  closeActivityHistory(): void {
    this.showActivityHistory = false;
  }
}
